import { computed, makeObservable, observable } from "mobx";
import { v4 as uuid } from "uuid";
import { IBox } from "../types/entities";
import { resolveBoxById } from "./relations";

export class Box {
  constructor(box: IBox) {
    makeObservable(this);

    Object.assign(this, box);
  }

  @observable
  id: string = uuid();

  @observable
  name: string = "";

  @observable
  photo: string = "";

  @observable.shallow
  typeTags: string[] = [];

  @observable
  description: string = "";

  @observable
  parentId: string | null = null;

  @computed
  get parent(): Box | undefined {
    if (this.parentId) {
      return resolveBoxById(this.parentId);
    }
    return undefined;
  }
}
